import React, { Component } from 'react';
// Composants
import { DateInput } from 'semantic-ui-calendar-react';
// Librairies
import { endOfDay, format, parse, startOfDay } from 'date-fns';
import { fr } from 'date-fns/locale';
import 'moment/locale/fr';
import 'moment/locale/nl';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import { connect } from 'react-redux';
// Utils
import LanguagesUtil from '../../utils/LanguagesUtil';
import { createPortal } from 'react-dom';
import { Button } from 'semantic-ui-react';
import i18n from '../../locales/i18n';

class DatePicker extends Component {
    state = {
        mobileOpen: false,
        closing: false, // pour gérer animation fermeture
        date: ''
    }

    render() {
        const { forceOpen } = this.props;

        return (
            <>
                {this.renderDatePickers()}
                {(this.state.mobileOpen || forceOpen) && this.renderMobileMenu()}
            </>
        );
    }

    renderDatePickers(isMobilePicker = false) {
        const { id, className, name, minDate, maxDate, initialDate, pointing, disabled, inputStyle } = this.props;
        const { date } = this.state;
        let popupPosition = pointing || 'top left';
        if (isMobileOnly) {
            popupPosition = popupPosition.replace('left', 'center');
            popupPosition = popupPosition.replace('right', 'center');
        }

        const culture = LanguagesUtil.getUserCulture(this.props.userInfos);
        const localization = culture.startsWith('fr') ? 'fr' : culture.startsWith('nl') ? 'nl' : 'en';
        const placeholder = culture.startsWith('fr') ? 'jj/MM/aaaa' : 'dd/MM/yyyy'
        const classNames = 'custom-date-picker' + (className ? ` ${className}` : '');
        const pointerEvents = !isMobilePicker && (isMobile || isTablet) ? 'none' : 'all';

        return (
            <div onClick={(e) => this.handleMobileTrigger(e)}>
                <DateInput
                    name={name} placeholder={placeholder} value={date} disabled={disabled} id={id} className={classNames} {...this.props} inline={isMobilePicker}
                    minDate={minDate ? startOfDay(minDate) : minDate} initialDate={minDate || maxDate || initialDate || new Date()} maxDate={maxDate ? endOfDay(maxDate) : maxDate}
                    dateFormat='DD/MM/yyyy' marked={new Date()} iconPosition='left' localization={localization} closable popupPosition={popupPosition} hideMobileKeyboard closeOnMouseLeave={false}
                    autoComplete='off' enable={disabled ? [date] : []} onChange={this.handleDateChange} style={{ ...inputStyle, pointerEvents }}
                />
            </div>
        );
    }

    renderMobileMenu() {
        const animationClass = this.state.closing ? 'closing' : 'opening';

        return createPortal(
            <div className={`mobile-select-overlay ${animationClass}`}>
                <div className="mobile-select-header">
                    <span>{i18n.t("Sélectionnez une date")}</span>
                    <Button icon='close' color='blue' size='small' style={{ marginRight: 0 }} onClick={this.handleMobileClose} />
                </div>
                <div className='mobile-select-options'>
                    {this.renderDatePickers(true)}
                </div>
            </div>,
            document.getElementById('mobile-modal')
        );
    }

    componentDidMount = () => this.initializeDate();
    componentDidUpdate = (prevProps) => {
        if ((!prevProps.value && this.props.value) || (prevProps.value !== this.props.value))
            this.initializeDate();
    }

    initializeDate = () => {
        const { value } = this.props;
        let date = '';

        if (Array.isArray(value)) {
            if (value.length) {
                date = format(value[0], 'dd/MM/yyyy') + ' - ';
                if (value.length > 1) date += format(value[1], 'dd/MM/yyyy');
            }
        } else if (value && value instanceof Date && !isNaN(value.getTime())) date = format(value, 'dd/MM/yyyy');

        this.setState({ date });
    }

    handleDateChange = (_, { name, value }) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;
        if (!this.props.disabled && value.match(regex)) {
            value = parse(value, 'dd/MM/yyyy', new Date(), { locale: fr });
            if (!this.props.forceTime) {
                const now = new Date();
                if (value) value.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
            } else if (value) value.setHours(23, 59, 59, 999);
            this.setState({ date: value }, () => {
                this.handleMobileClose();
                this.props.onChange(_, { name, value: isFinite(value) ? value : null });
            });
        } else if (!this.props.disabled) this.setState({ date: value }, () => {
            this.handleMobileClose();
            this.props.onChange(_, { name, value: null });
        });
    }

    handleDatesChange = (_, { name, value }) => {
        this.setState({ date: value }, () => {
            if (value) {
                let dates = value.split(' - ').map(date => parse(date, 'dd/MM/yyyy', new Date(), { locale: fr })).filter(date => !isNaN(date.getTime()));
                if (!this.props.forceTime) {
                    const now = new Date();
                    if (dates[0]) dates[0].setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
                    if (dates[1]) dates[1].setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
                } else {
                    if (dates[0]) dates[0].setHours(0, 0, 0, 0);
                    if (dates[1]) dates[1].setHours(23, 59, 59, 999);
                }
                this.props.onChange(_, { name, value: dates });
            } else this.props.onChange(_, { name, value: [] });
        });
    }

    handleMobileTrigger = (e) => {
        if (isMobile || isTablet) {
            e.preventDefault();
            e.stopPropagation();

            if (document.activeElement && typeof document.activeElement.blur === 'function')
                document.activeElement.blur();

            setTimeout(() => {
                this.setState({ mobileOpen: true });
            }, 100);
        }
    }

    handleMobileClose = () => {
        // Lance l’animation de fermeture
        this.setState({ closing: true }, () => {
            // Après la durée de l’animation, on ferme vraiment le menu
            setTimeout(() => {
                this.setState({ mobileOpen: false, closing: false }, () => {
                    if (this.props.onClose) this.props.onClose();
                });
            }, 300); // durée de l’animation CSS
        });
    }
}

const mapStateToProps = (state) => {
    return {
        userInfos: state.userInfos
    };
};

export default connect(mapStateToProps)(DatePicker);